var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_8460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.75C23.3083 12.75 22.75 12.1917 22.75 11.5V5.25C22.75 4.55833 23.3083 4 24 4C24.6917 4 25.25 4.55833 25.25 5.25V11.5C25.25 12.1917 24.6917 12.75 24 12.75Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24 44C23.3083 44 22.75 43.4417 22.75 42.75V36.5C22.75 35.8083 23.3083 35.25 24 35.25C24.6917 35.25 25.25 35.8083 25.25 36.5V42.75C25.25 43.4417 24.6917 44 24 44Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M15.1583 16.408C14.8416 16.408 14.5166 16.283 14.2749 16.0413L9.85825 11.6247C9.36659 11.133 9.36659 10.3413 9.85825 9.85801C10.3499 9.36634 11.1416 9.36634 11.6249 9.85801L16.0416 14.2747C16.5333 14.7663 16.5333 15.558 16.0416 16.0413C15.7999 16.283 15.4749 16.408 15.1583 16.408Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.2583 38.5084C36.9417 38.5084 36.6167 38.3834 36.375 38.1417L31.9583 33.7251C31.4667 33.2334 31.4667 32.4417 31.9583 31.9584C32.45 31.4751 33.2417 31.4667 33.725 31.9584L38.1417 36.3751C38.6334 36.8667 38.6334 37.6584 38.1417 38.1417C37.9 38.3834 37.575 38.5084 37.2583 38.5084Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.5 25.25H5.25C4.55833 25.25 4 24.6917 4 24C4 23.3083 4.55833 22.75 5.25 22.75H11.5C12.1917 22.75 12.75 23.3083 12.75 24C12.75 24.6917 12.1917 25.25 11.5 25.25Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.75 25.25H36.5C35.8083 25.25 35.25 24.6917 35.25 24C35.25 23.3083 35.8083 22.75 36.5 22.75H42.75C43.4417 22.75 44 23.3083 44 24C44 24.6917 43.4417 25.25 42.75 25.25Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.7416 38.5086C10.4249 38.5086 10.0999 38.3836 9.85825 38.1419C9.36659 37.6503 9.36659 36.8586 9.85825 36.3753L14.2749 31.9586C14.7666 31.4669 15.5583 31.4669 16.0416 31.9586C16.5333 32.4503 16.5333 33.2419 16.0416 33.7253L11.6249 38.1419C11.3833 38.3836 11.0583 38.5086 10.7416 38.5086Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.8417 16.408C32.525 16.408 32.2 16.283 31.9583 16.0413C31.4667 15.5497 31.4667 14.758 31.9583 14.2747L36.375 9.85801C36.8667 9.36634 37.6584 9.36634 38.1417 9.85801C38.6334 10.3497 38.6334 11.1413 38.1417 11.6247L33.725 16.0413C33.4833 16.283 33.1584 16.408 32.8417 16.408Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_8460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loading_icon.8739a97f34301f3bda4b12ca800c4f04.svg";
export { ForwardRef as ReactComponent };